import Annotators from './Annotators';

export default Annotators;
